import { baseRoutes } from "helpers/baseRoutes";

const accessRoute = {
  MANAGE_CMS: {
    path: `${baseRoutes.adminBaseRoutes}`,
    icon: (
      <span className="nk-menu-icon">
        <em className="icon-desktop" />
      </span>
    ),
  },
  TERMS_AND_CONDITION: {
    path: `${baseRoutes.adminBaseRoutes}/terms-and-conditions`,
  },
  PRIVACY_POLICY: {
    path: `${baseRoutes.adminBaseRoutes}/privacy-policy`,
  },
  ABOUT_US: {
    path: `${baseRoutes.adminBaseRoutes}/about-us`,
  },
  FAQS: {
    path: `${baseRoutes.adminBaseRoutes}/faq`,
  },
};

export default accessRoute;
